import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter036() {
  return <KbChapterPage slug="chapter-036" />;
}

(Chapter036 as unknown as { path: string }).path = "/theory-album/036";
